import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/fila`

    return {
        paciente: {
            autocomplete(queryParms = {}) {

                return repository.get(`${baseUrl}/autocomplete-paciente?${urlUtil.serialize(queryParms)}`)
            }
        },
        datatable(queryParms = {}) {

            return repository.post(`${baseUrl}/datatable`, queryParms)
        },
        list(params) {

            return repository.post(`${baseUrl}/list`, params)
        },
        getDadosAmbulatorio(solicitacaoId) {

            return repository.get(`${baseUrl}/dados-ambulatorio/${solicitacaoId}`)
        }
    }
}